import React from 'react'

const Loading = () => {
  return <h6>Authentication in progress...</h6>
}

export default Loading
